var App = App || {};

App.NewsArticles = (function ($) {
    "use strict";

    var $categorySelector;

    function init() {
        $categorySelector = $('#news-articles-category-selector');
        $categorySelector.on('change', function () {
            location.href = "?category=" + $(this).val();
        });
    }

    return {
        init: init
    }
})(jQuery);

$(function () {
    App.NewsArticles.init();
});